// Module
var code = "<div class=\"md-whiteframe-z1 mn-module flex layout-row front-desk-loader\" layout-align=\"space-around center\">\r\n    <md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular>\r\n</div>";
// Exports
module.exports = code;